import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LegView } from '@sequence/models/view/leg.view';
import { RequestState } from '@shared/models/request-state';
import { Observable } from 'rxjs';
import { SeatMapView, SeatType } from '../models/seat-map.view';
import { SeatMapService } from '../seat-map.service';

@Component({
  selector: 'app-seat-map',
  templateUrl: './seat-map.component.html',
  styleUrl: './seat-map.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeatMapComponent implements OnInit {
  dialog = inject(MatDialog);
  seatMapService = inject(SeatMapService);
  data = inject<{ flightState: LegView }>(MAT_DIALOG_DATA);

  seatMap$?: Observable<RequestState<SeatMapView>>;

  SeatType = SeatType;

  ngOnInit(): void {
    this.seatMap$ = this.seatMapService.getSeatMap(
      this.data.flightState,
      false,
    );
  }

  refresh(): void {
    this.seatMap$ = this.seatMapService.getSeatMap(this.data.flightState, true);
  }
}
